/* eslint 'jsx-a11y/alt-text': 'off', 'no-useless-concat' : 'off', 'no-dupe-keys' : 'off', eqeqeq: 'off', no-useless-escape: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label, Form, Table, Modal } from 'reactstrap';
import { Redirect } from 'react-router-dom';
//import { FaPencilAlt as Edit } from 'react-icons/fa';
import EditPreventativeMaintenance from './EditPreventativeMaintenance';
import AddPartsForm from "./AddPartsForm";
import { GetPreventativeMaintenanceDetails, DownloadAttachment, GetWorkOrderBuildingsList, DeletePreventativeMaintenance,SavePMComments,UpdatePMComments,DeletePMComments,DeletePMParts,DeletePMLaborDetails, GetPreventativeMaintenanceCustomFields } from "../../../../action/workorderAction";
import { Icon } from 'semantic-ui-react';
import DeleteConfirmation from '../../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import { closeModalPopUp } from '../../../../action/modalStateAction';
import AddLaborForm from "./AddLaborForm";
import EditIcon from '../../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FaPrint } from 'react-icons/fa';
import TraneLogo from '../../../../Assets/icons/Icons__trane-logo.svg';
import TraneTechLogo from '../../../../Assets/icons/tt_logo_tm_color_rgb.png';

let EditPartsDetails = [], EditLaborDetails = [], PMSerialNumber = '';
let PMId;
const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
};

class PreventativeMaintenanceDetails extends Component {

    componentWillMount() {
        PMId = this.props.PMId;
        this.props.GetPreventativeMaintenanceDetails(PMId);
        this.props.GetWorkOrderBuildingsList();
        this.props.GetPMCustomFields();
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
            if (modalClose == "close") {
                this.setState({ modal: false, labormodal: false });
            }
        }
    }

    componentDidUpdate() {
          if(this.state.redirectHistoryPM){
                PMId = this.state.SetPMHistoryId;
                this.props.GetPreventativeMaintenanceDetails(PMId);
                this.props.GetWorkOrderBuildingsList();
                this.setState({redirectHistoryPM:false,onHistoryChange:false});
          }
    }

    constructor(props) {
        super(props);
        this.state = {
            redirectHome: false,
            redirectToEdit: false,
            StatusId: this.props.StatusId,
            redirectHistoryPM: false,
            SetPMHistoryId: 0, 
            deletemodal: false,
            onCommentChange: false,
            onHistoryChange: false,
            commentModal: 'none',
            PmCommentID: 0,
            labormodal: false,
            isEdit: false,
            isLaborEdit: false,
            sort: {
                column: null,
                direction:[
                  {name:'comments', direction: 'desc'},
                  {name:'createdByUserName',direction:'desc'},
                  {name:'createdOn',direction:'desc',onclick:true},
                  {name:'partName',direction:'desc'},
                  {name:'partNumber',direction:'desc'},
                  {name:'quantity',direction:'desc'},
                  {name:'userName',direction:'desc'},
                  {name:'dateOfService',direction:'desc'},
                  {name:'regularHour',direction:'desc'},
                  {name:'timeDuration',direction:'desc'},
                  {name:'id',direction:'desc',onclick:true},
                  {name:'dueDate',direction:'desc'},
                  {name:'closedDate',direction:'desc'},
                  {name:'assignedTo',direction:'desc'},
                ],
            },
            isCommentEmpty: false,
        }
        this.Delete = this.Delete.bind(this);
        this.OpenDeletePopup = this.OpenDeletePopup.bind(this);
        this.switchEditView = this.switchEditView.bind(this);
        this.AttachmentDownload = this.AttachmentDownload.bind(this);
        this.toggle = this.toggle.bind(this);
        this.Edittoggle = this.Edittoggle.bind(this);
        this.DeleteParts = this.DeleteParts.bind(this);
        this.Labortoggle = this.Labortoggle.bind(this);
        this.DeleteLabor = this.DeleteLabor.bind(this);
        this.ViewPMDetails = this.ViewPMDetails.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
    }

    switchEditView() {
        this.setState({ redirectToEdit: !this.state.redirectToEdit });
    }

    ViewPMDetails(Id,StatusId){
        this.setState({ redirectHistoryPM: true, SetPMHistoryId: Id,StatusId: StatusId });
        var el = document.getElementsByClassName('Ensemble_Content_FullPage'); 
        if(el[0] !== undefined)
            el[0].scrollIntoView();
    }

    togglePMList() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        
        if(IsEquipment)
        {
            this.props.UpdateRedirection();
            this.props.ShowCreateButton();
        }

        this.setState({ redirectHome: true });
    }

    onLaborSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.PreventativeMaintenanceDetail.labors;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.PreventativeMaintenanceDetail.labors.sort((a, b) => {
                let nameA, nameB;
                if (column === "userName") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    if (column === "regularHour" || column === "timeDuration") {
                        nameA = a[column];
                        nameB = b[column];
                    }
                    else {
                        nameA = new Date(a[column]);
                        nameB = new Date(b[column]);
                    }
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.PreventativeMaintenanceDetail.labors = sortedData;
            if(selected[0].name == "userName"){
                copydata[6].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "userName" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "dateOfService"){
                copydata[7].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "dateOfService" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "regularHour"){
                copydata[8].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "regularHour" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            if(selected[0].name == "timeDuration"){
                copydata[9].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "timeDuration" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});  
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
            });
        }
        return 0;
    }

    toggle() {
        EditPartsDetails = [];
        this.props.closeModalPopUp("open");
        this.setState({
            modal: true,
            isEdit: false
        });
    }

    AttachmentDownload(fileName) {
        this.props.DownloadAttachment(fileName);
    }

    OpenPrintPreview(){
        var imgURL = document.getElementById('test_trane_logo').src;
        document.getElementById('PrintPMSummary').setAttribute('style','display:block');
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var PrintSummaryContent = document.getElementById('PrintPMSummary').outerHTML;
        var WindowHeight = ((window.screen.height)-10) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, toolbar=no, menubar=no, scrollbars=yes, location=no, directories=no, status=no');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;" ><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');

        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class=\'row row_padding\'><div class='\col-md-12\'>");
        writeMe += ("<br/><label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float:left;margin-left:16px;'>Preventative Maintenance</label><label class=\'workOrderlabel'\ style='float:right;margin-right:16px;'>"+CurrentDate+"</label><br/>");
        writeMe += ("<div style='margin:16px'><nav style='position: relative;display: -webkit-flex;display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;-webkit-align-items: center;align-items: center;-webkit-justify-content: space-between;justify-content: space-between;padding: .5rem 1rem;background: transparent linear-gradient(270deg, #104095 0%, #2070CF 100%) 0% 0% no-repeat padding-box !important; min-height: 54px;-webkit-flex-flow: row nowrap;flex-flow: row nowrap;-webkit-justify-content: flex-start;justify-content: flex-start;'><a><img id='Trane_Logo' src="+imgURL+"></a></nav></nav></div>");
        writeMe += ("<label style='height: 15px;text-align: left;letter-spacing: 0px;color: #4A4A4A;opacity: 1;font-weight: bold;font-family: lato;font-size: 15px;padding-left: 15px;'>"+PMSerialNumber+"</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/>");
        writeMe += ("<div id='divWODetailsPrintPreview'>" + printContent + PrintSummaryContent + "</div>");
        writeMe += ("<br/><br/><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class=\'print_footer'\ style='padding-left: 16px; padding-bottom: 3px;'>Tracer Ensemble<br/>2020 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='float:right'><img id='TraneTech_Logo' style='height: 30px;width: 142px;padding-right: 11px;' src="+TraneTechLogo+" \></div><br/>");
        writeMe += ("<div style='borderTop:1px solid #FFFFFF; padding-bottom: 50px;'/><div style='margin-top:10px; margin-bottom:25px; margin-right:5px'><div style='float:right;'>");
        writeMe += ('<button type=\'button\' class=\'wo_cancel_btn hide_in_print\' style=\'color: #1756B2;border:0px;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;width: 80px;height: 30px;float: right; margin-left: 6px; margin-top:3px; margin-right:10px; width:106px\' id=\'btnPrint\' onclick=\'javascript:window.close();\' >' + 'Close Window' + '</button>');
        writeMe += ('<button type=\'button\' class=\'wo_save_btn hide_in_print\' style=\'border:0px;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; margin-top:3px\' id=\'btnPrint\' onclick=\'javascript:window.print();\' >' + 'Print' + '</button>');
        writeMe += ("</div></div><br/>");
        writeMe += ('</body></html>');    
        printWindow.document.write(writeMe);
        printWindow.document.close();    
        printWindow.focus();
        document.getElementById('PrintPMSummary').setAttribute('style','display:none');
    }


    OnStatusSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    OpenDeletePopup() {
        this.Deletetoggle();
    }

    Delete(someArg) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if (someArg == "yes") { 
            var Data = [];
            Data.push(PMId);
            if(IsEquipment){
                this.props.DeletePreventativeMaintenance(Data,this.props.getDetails.PreventativeMaintenanceDetail.equipmentId);
                this.props.UpdateRedirection();
                this.props.ShowCreateButton();
            }    else{
                this.props.DeletePreventativeMaintenance(Data);
            }    
           
            this.setState({ redirectHome: true });
        }
        else {
            this.Deletetoggle();
        }
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    SavePMComments() {
        var lComment = this.refs.WorkOrder_Comments.value;
        let isValid = (lComment !== "") ? true : false;
        this.setState({onCommentChange:false, isCommentEmpty:false});
        if(isValid){
            var data = {
                Comments: lComment,
                CreatedByUserID: 1,
                PMId: this.props.getDetails.PreventativeMaintenanceDetail.id,
                commentId: this.state.PmCommentID
            }
            if (this.state.PmCommentID !== 0)
                this.props.SavePMComments(data);
            else
                this.props.UpdatePMComments(data);
            this.toggleComments();
        } else{
            this.setState({isCommentEmpty: true})
        }
    }

    EditComments(ID, lComments) {
        if (this.state.commentModal === 'none')
            this.setState({ commentModal: 'block' });
        this.setState({ PmCommentID: ID });
        this.refs.WorkOrder_Comments.value = lComments;
    }

    DeleteComments(ID) {
        var data = {
            PMId: this.props.getDetails.PreventativeMaintenanceDetail.id,
            commentId: ID
        }
        this.props.DeletePMComments(data);
    }


    toggleComments() {
        this.refs.WorkOrder_Comments.value = "";
        this.setState({ PmCommentID: 0,isCommentEmpty:false });
        if (this.state.commentModal === 'none')
            this.setState({ commentModal: 'block' });
        else
            this.setState({ commentModal: 'none' });
    }

    onCommentSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.PreventativeMaintenanceDetail.comments;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.PreventativeMaintenanceDetail.comments.sort((a, b) => {
                let nameA, nameB;
                if (column === "createdByUserName" || column === "comments") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    nameA = new Date(a[column]);
                    nameB = new Date(b[column]);
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.PreventativeMaintenanceDetail.comments = sortedData;
            if(selected[0].name == "comments"){
                copydata[0].direction = direction; 
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "comments") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});                 
            }
            if(selected[0].name == "createdByUserName"){
                copydata[1].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "createdByUserName") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array}); 
                
            }
            if(selected[0].name == "createdOn"){
                copydata[2].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});                
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
                onCommentChange:true,
            });
        }
        return 0;
    }

    Edittoggle(Name, number, quantity, PartId) {
        EditPartsDetails = [];
        this.props.closeModalPopUp("open");
        EditPartsDetails.push({ partName: Name, partNumber: number, quantity: quantity, partId: PartId });
        this.setState({
            modal: true,
            isEdit: true
        })
    }


    DeleteParts(element) {
        this.props.DeletePMParts(element);
    }

    onPartsSort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.PreventativeMaintenanceDetail.parts;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.PreventativeMaintenanceDetail.parts.sort((a, b) => {
                let nameA, nameB;
                if (column === "partName" || column === "partNumber") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                else {
                    nameA = a[column];
                    nameB = b[column];
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.PreventativeMaintenanceDetail.parts = sortedData;
            if(selected[0].name == "partName"){
                copydata[3].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "partName" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "partNumber"){
                copydata[4].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "partNumber" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "quantity"){
                copydata[5].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "quantity" && x.name !== "createdOn") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
            });
        }
        return 0;
    };

    onHistorySort = (column) => (e) => {
        var copydata = this.state.sort.direction.slice();
        var selected = copydata.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getDetails.PreventativeMaintenanceDetail.history;
        var notequals = 0;
        if (data_from_state !== null) {
            const sortedData = this.props.getDetails.PreventativeMaintenanceDetail.history.sort((a, b) => {
                let nameA, nameB;
                
                nameA = a[column];
                nameB = b[column];
                
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            this.props.getDetails.PreventativeMaintenanceDetail.history = sortedData;
            if(selected[0].name == "id"){
                copydata[10].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "id") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "dueDate"){
                copydata[11].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "dueDate") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "closedDate"){
                copydata[12].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "closedDate") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            if(selected[0].name == "assignedTo"){
                copydata[13].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "assignedTo") ? x.onclick=false : x.onclick=true);
                this.setState({copydata:array});    
            }
            this.setState({
                sort: {
                    column,
                    direction:copydata,
                },
                onHistoryChange:true,
            });
        }
        return 0;
    };

    Labortoggle() {
        this.props.closeModalPopUp("open");
        this.setState({
            labormodal: true,
            isLaborEdit: false
        });
    }

    EditLabor(data) {
        EditLaborDetails = [];
        this.props.closeModalPopUp("open");
        EditLaborDetails.push({ laborId: data.laborId, userName: data.userName, dateOfService: data.dateOfService, regularHour: data.regularHour, timeDuration: data.timeDuration });
        this.setState({
            labormodal: true,
            isLaborEdit: true
        })
    }

    DeleteLabor(element) {
        this.props.DeletePMLaborDetails(element);
    }

    OnSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    FormEmptyCustomFields(){
        const l_rows = [];
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length)
        {
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length)
            {
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    return <Col sm={{ size: 2 }}>
                        <Label className='workorderheaderlbl'>{item.fieldLabel}</Label><br />
                        <Label className="workorderlbl">---</Label>
                    </Col>
                });

                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div className="row form-group">
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    FormCustomFields(PMCustomFields){
        const l_rows = [];
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length)
        {
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    var SelectedValues = PMCustomFields.filter(el => el.customFieldId === item.fieldId);
                    var l_Value = "";
                    if(SelectedValues[0] !== undefined && SelectedValues[0] !== null)
                    {
                       if(item.fieldType === 0)
                       {
                            l_Value = SelectedValues[0].customFieldTextValue;
                       }else{
                            if (item.value !== undefined && item.value !== null && item.value.length > 0) {
                                var l_Values = item.value.filter(ele => ele.key === SelectedValues[0].customFieldValueId);
                                l_Value = (l_Values[0] !== undefined && l_Values[0] !== null) ? l_Values[0].value : "";
                            }
                       }
                    }
                    return  <Col sm={{ size: 2 }}>
                                <Label className='workorderheaderlbl'>{item.fieldLabel}</Label><br />
                                <Label className="workorderlbl">{l_Value !== "" ? l_Value : "---"}</Label>
                            </Col>
                });
                   // Push a new row for every set of three fields
                   for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div className="row form-group">
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                    }
                }
            }
            return l_rows;
        }

    render(getLabels, getDetails, getWorkorderPreferences,UserCanEdit) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if (this.state.redirectHome  && !IsEquipment) {
            return <Redirect to={"/ManagePreventativeMaintenance"} />
        }  else if(this.state.redirectHome && IsEquipment){
            return <Redirect to ={"/EquipmentWrapper"}/>
        }

        let lUserCanEdit;
        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit === 3 ? true : false;

        let label = this.props.getLabels;
        let PMDetails = this.props.getDetails.PreventativeMaintenanceDetail;
        let PMPreferences = this.props.getPreferences;

        var Status = '', AssignedTo = '', Name = '', Building = '', Equipment = '', Schedule = '', Description = '', EstimateTime = '', PartsAndTools = '', TaskList = '', FamilyType = '', PMCustomFields = [], notifyOthers = '';

        if (PMPreferences != undefined && PMPreferences != '') {
            Status = PMPreferences.filter(x => x.field === "Status" && x.display === true);
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To" && x.display === true);
            Name = PMPreferences.filter(x => x.field === "Name" && x.display === true);
            Building = PMPreferences.filter(x => x.field === "Building" && x.display === true);
            Equipment = PMPreferences.filter(x => x.field === "Equipment" && x.display === true);
            Schedule = PMPreferences.filter(x => x.field === "Schedule" && x.display === true);
            Description = PMPreferences.filter(x => x.field === "Description" && x.display === true);
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time" && x.display === true);
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools" && x.display === true);
            TaskList = PMPreferences.filter(x => x.field === "Task List" && x.display === true);
            FamilyType = PMPreferences.filter(x => x.field === "Family Type" && x.display === true);
            notifyOthers = PMPreferences.filter(x => x.field === "Notify Others" && x.display === true);
        }

        let  PMAttachements, PMStatus, IsClosedStatus = 'block', PMAssignedTo, PMName = "", IsPastDue = false, PMScheduledDate,PMClosedDate, PMBuilding, PMEquipment, PMFamilyName, PMScheduleText, PMEstimatedTime, PMDescription, PMTaskList = "---", Parts,PMComments,Labors,PMParts = "---",PMHistory, PMNotifyOthers;
        let IsBasedOnUsage = false, UsageRemaining = null;
        let PrintPMAttachements,PrintParts,PrintLabor,PrintPMComments,PrintHistory;

        if (PMDetails !== undefined && PMDetails !== null) {
            PMSerialNumber = PMDetails.serialNumber;
            PMName = (PMDetails.name !== "" ? PMDetails.name : "---");
            PMFamilyName = PMDetails.familyName !== null ? PMDetails.familyName : '---';
            PMScheduledDate = (PMDetails.dueDate === '1753-01-01T00:00:00' || PMDetails.dueDate === '0001-01-01T00:00:00') ? '---' : new Date(PMDetails.dueDate).toDateString();
            PMClosedDate = (PMDetails.closedDate === '1753-01-01T00:00:00' || PMDetails.closedDate === '0001-01-01T00:00:00') ? '---' : new Date(PMDetails.closedDate).toDateString();
            PMScheduleText = (PMDetails.scheduleType === 1 || PMDetails.scheduleType === 2) ?  PMDetails.scheduleText : '---';
            IsBasedOnUsage = PMDetails.scheduleType === 2 ? true : false;
            UsageRemaining = PMDetails.remainingUsage;
            
            if (PMDetails.scheduleType === 1 && PMScheduleText == '')
            {    
                var recurdate = new Date(PMDetails.schedule.startDate);
                var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
                PMScheduleText = "Starting " + forma + ", " + "Every " + ((PMDetails.schedule.modifier != 1) ? PMDetails.schedule.modifier : "") + " " + label['CreatePM.Interval.' + PMDetails.schedule.interval + '.Text'] + ((PMDetails.schedule.modifier != 1) ? "s" : "");
            }
            
       
            PMEstimatedTime = (PMDetails.estimatedTime == undefined || PMDetails.estimatedTime === '00:00:00')  ? '---' : PMDetails.estimatedTime.split(':')[0] + ":" + PMDetails.estimatedTime.split(':')[1];

            var l_SiteId = PMDetails.buildingId;
            IsClosedStatus = PMDetails.status === 6 ? 'none' : 'block';
            PMStatus = PMDetails.status !== 0 ? (Status.length > 0 ? Status[0].value.filter(x => x.key == PMDetails.status)[0] !== undefined ? Status[0].value.filter(x => x.key == PMDetails.status)[0].value : "" : "---") : "---";

            var TechnicianName = '';
            var NotifyOtherslst = <Label className="workorderlbl">---</Label>;
            if (this.props.getTechnicianList != undefined && this.props.getTechnicianList.length) {
                if(this.props.getTechnicianList.filter(el => el.technicianID == PMDetails.assignedTo)[0] != undefined)
                {
                  var TechName = this.props.getTechnicianList.filter(el => el.technicianID == PMDetails.assignedTo);
                  TechnicianName = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].name : '';
                }
                
                if (PMDetails.notifyUserIDs.length && PMDetails.notifyUserIDs !== undefined && PMDetails.notifyUserIDs !== null) {
                    NotifyOtherslst = PMDetails.notifyUserIDs.map(e => {
                        var technicianName = this.props.getTechnicianList.filter(el => el.technicianID == e)[0].name
                        return (
                            <>
                                <Label className="workorderlbl">{technicianName}</Label><br />
                            </>
                        )
                    })
                }
            }
            PMAssignedTo = (TechnicianName !== "" ? TechnicianName : "---");
            PMNotifyOthers = NotifyOtherslst;
            
            if (PMScheduledDate !== '---') {
                IsPastDue = PMDetails.status === 6 ? false : PMDetails.isDueDatePassed;
            }
            var l_Buildings = l_SiteId > 0 ?(this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] != undefined ? this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] : null): null;
            PMBuilding = (l_SiteId > 0 && l_Buildings != undefined) ? l_Buildings.name : '---';
            PMEquipment = (PMDetails.equipmentName != null && PMDetails.equipmentName != "") ? PMDetails.equipmentName : "---";
            PMDescription = PMDetails.description;
            var PMParts1 =PMDetails.partsTools !== undefined ? (PMDetails.partsTools !== "" ? PMDetails.partsTools.split('\n') : PMDetails.partsTools) : "";

            if (PMDetails.attachments !== null && PMDetails.attachments !== [] && PMDetails.attachments.length) {
                var lAttachements = PMDetails.attachments;
                PMAttachements = lAttachements.map(el => (
                    <tr>
                        <td className="link_cursorUnderline" onClick={() => { this.AttachmentDownload(el.fileName) }}>{el.name}</td>
                    </tr>
                ));
                PrintPMAttachements = lAttachements.map(el => (
                    <tr>
                        <td>{el.attachmentName}</td>
                    </tr>
                ));
            }
            else{
                PMAttachements = <tr><td className="workorderlbl-noentry">{"No attachments"}</td></tr> 
                PrintPMAttachements = <tr><td className="workorderlbl-noentry">{"No attachments"}</td></tr> 
            }
            
            if (PMParts1 !== undefined && PMParts1.length) {
                PMParts = PMParts1.map((el) => (
                    <li><span className="workorderlbl">{el}</span></li>
                ));
            }
            if (PMDetails.tasks !== null && PMDetails.tasks !== [] && PMDetails.tasks.length) {
                PMTaskList = PMDetails.tasks.map((el, index) => (
                    <tr key={el.taskId}>
                        <th style={{ width: "1%", bordertop: "0 solid" }}>
                            <input className="pm_regular_checkbox" type="checkbox" disabled="true" defaultChecked={el.isChecked} ref={'ref_' + el.taskId} value={el.taskId} />
                        </th>
                        <td className="workorderlbl" style={{ width: "50%", bordertop: "0 solid" }}>{el.taskDescription}</td>
                    </tr>
                ));
            }

            if (PMDetails.comments !== undefined && PMDetails.comments !== null && PMDetails.comments !== [] && PMDetails.comments.length) {
                let comment = PMDetails.comments;
                if(!this.state.onCommentChange){
                    let comments = comment.sort((a,b)=>{
                        let nameA = a.createdOn;
                        let nameB = b.createdOn;
                        if(nameA < nameB)
                            return(-1);
                        else
                            return(1);
                    });
                    comment = comments.reverse();
                 }
                 PMComments = comment.map(el => (
                    <tr key={el.commentId}>
                        <td>{el.comments}</td>
                        <td>{el.createdByUserName !== "" ? el.createdByUserName : ''}</td>
                        <td>{new Date(el.createdOn).toDateString()}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.EditComments(el.commentId, el.comments) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteComments(el.commentId) }} />
                        </td>
                    </tr>
                ));
                PrintPMComments = comment.map(el => (
                    <tr key={el.commentId}>
                        <td>{el.comments}</td>
                        <td>{el.createdByUserName !== "" ? el.createdByUserName : ''}</td>
                        <td>{new Date(el.createdOn).toDateString()}</td>
                    </tr>
                ));
            } else {
                PMComments = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
                PrintPMComments = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
            }

            if (PMDetails.parts !== undefined && PMDetails.parts !== null && PMDetails.parts.length) {
                Parts = PMDetails.parts.map(el => (
                    <tr key={el.partID}>
                        <td width="30%">{el.partName}</td>
                        <td width="30%">{el.partNumber}</td>
                        <td width="24%">{el.quantity}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.Edittoggle(el.partName, el.partNumber, el.quantity, el.partId) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteParts(el) }} />
                        </td>
                    </tr>
                ));
                PrintParts = PMDetails.parts.map(el => (
                    <tr>
                        <td width="30%">{el.partName}</td>
                        <td width="30%">{el.partNumber === "" ? '' : el.partNumber}</td>
                        <td width="24%">{el.quantity === 0 ? '' : el.quantity}</td>
                    </tr>
                ));
            } else {
                Parts = <tr><td className="workorderlbl-noentry" colSpan="4">No Entry</td></tr>;
                PrintParts = <tr><td className="workorderlbl-noentry" colSpan="3">No Entry</td></tr>;
            }

            if (PMDetails.labors !== undefined && PMDetails.labors !== null && PMDetails.labors.length) {
                Labors = PMDetails.labors.map(el => (
                    <tr key={el.laborID}>
                        <td width="25%">{el.userName}</td>
                        <td width="25%">{el.dateOfService === "1753-01-01T00:00:00" ? '---' : new Date(el.dateOfService).toDateString()}</td>
                        <td width="20%">{el.regularHour === 0 ? '---' : el.regularHour}</td>
                        <td width="19%">{el.timeDuration === 0 ? '---' : el.timeDuration}</td>
                        <td width="11%">
                            <img src={EditIcon} style={{width:'18px'}} onClick={() => { this.EditLabor(el) }} />
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteLabor(el) }} />
                        </td>
                    </tr>
                ))
                PrintLabor =PMDetails.labors.map(el => (
                    <tr>
                        <td width="25%">{el.userName}</td>
                        <td width="25%">{el.dateOfService === "1753-01-01T00:00:00" ? '' : new Date(el.dateOfService).toDateString()}</td>
                        <td width="20%">{el.regularHour === 0 ? '' : el.regularHour}</td>
                        <td width="19%">{el.timeDuration === 0 ? '' : el.timeDuration}</td>
                    </tr>
                ))
            } else {
                Labors = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
                PrintLabor = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
            }

            if (PMDetails.history !== undefined && PMDetails.history !== null && PMDetails.history.length) {               
                let history = PMDetails.history;
                if(!this.state.onHistoryChange){
                    let historys = history.sort((a,b)=>{
                        let nameA = a.id;
                        let nameB = b.id;
                        if(nameA < nameB)
                            return(-1);
                        else
                            return(1);
                    });
                    history = historys.reverse();
                 }


                PMHistory = history.map(el => (
                    <tr key={el.id}>
                        <td width="25%"><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ViewPMDetails(el.id,PMDetails.status) }}>{el.serialNumber}</p></td>
                        <td width="25%">{(el.dueDate === '0001-01-01T00:00:00' || el.dueDate === '1753-01-01T00:00:00') ? "---" : new Date(el.dueDate).toDateString()}</td>
                        <td width="20%">{(el.closedDate === '0001-01-01T00:00:00') ? "---" : new Date(el.closedDate).toDateString()}</td>
                        <td width="19%">{this.props.getTechnicianList.filter(e2 => e2.technicianID == el.assignedTo)[0] !== undefined ? this.props.getTechnicianList.filter(e2 => e2.technicianID == el.assignedTo)[0].name : "---"}</td>
                        <td></td>
                    </tr>
                ))
                PrintHistory = history.map(el => (
                    <tr key={el.id}>
                        <td width="25%"><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ViewPMDetails(el.id,PMDetails.status) }}>{el.serialNumber}</p></td>
                        <td width="25%">{(el.dueDate === '0001-01-01T00:00:00' || el.dueDate === '1753-01-01T00:00:00') ? "---" : new Date(el.dueDate).toDateString()}</td>
                        <td width="20%">{(el.closedDate === '0001-01-01T00:00:00') ? "---" : new Date(el.closedDate).toDateString()}</td>
                        <td width="19%">{this.props.getTechnicianList.filter(e2 => e2.technicianID == el.assignedTo)[0] !== undefined ? this.props.getTechnicianList.filter(e2 => e2.technicianID == el.assignedTo)[0].name : "---"}</td>
                        <td></td>
                    </tr>
                ))
            } else {
                PMHistory = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
                PrintHistory = <tr><td className="workorderlbl-noentry" colSpan="5">No Entry</td></tr>
            }

            if(PMDetails.customFields !== undefined && PMDetails.customFields !== null && PMDetails.customFields.length)
            {
                PMCustomFields = this.FormCustomFields(PMDetails.customFields);
            }else{
                PMCustomFields = this.FormEmptyCustomFields();
            }
        }

        let PrintPMSummary = <div>
            <FormGroup row>
                {
                    <Col sm={{ size: 8 }}>
                        <Label className="workorderlbl" style={{ 'margin-bottom': '10px' }}>Attached Documents or Photos</Label><br />
                        <Table responsive className="attachmentTable" style={{ width: "90%", border: "none" }}>
                            <tbody>
                                <tr><th>FILE NAME</th></tr>
                                {PrintPMAttachements}
                            </tbody>
                        </Table>
                    </Col>
                }
            </FormGroup>
            <hr style={{ 'margin-bottom': '0px', 'background-color': 'black' }} />
            <FormGroup row>
                <Col sm={{ size: 12 }}>
                    <Label style={{ "padding-top": "24px" }} className='workorderlbl'>{label['WorkOrderDetails.WorkSummary.Text'] !== undefined ? label['WorkOrderDetails.WorkSummary.Text'] : "WORK SUMMARY"}</Label>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrders.ViewDetails.Parts.Text'] !== undefined ? label['WorkOrders.ViewDetails.Parts.Text'] : "Parts"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table" style={{ 'table-layout': 'fixed' }}>
                            <tbody className="cell_container">
                                <tr>
                                    <th width="20%">{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}</th>
                                    <th width="40%">{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}</th>
                                    <th width="20%">{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}</th>
                                </tr>
                                {PrintParts}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Labor.text'] !== undefined ? label['WorkOrderDetails.Labor.text'] : "Labor"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table" style={{ 'table-layout': 'fixed' }}>
                            <tbody className="cell_container">
                                <tr>
                                    <th width="20%">{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}
                                    </th>
                                    <th width="20%">{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}
                                    </th>
                                </tr>
                                {PrintLabor}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Comments.Text'] !== undefined ? label['WorkOrderDetails.Comments.Text'] : "Comments"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table fixed_layout">
                            <tbody className="cell_container">
                                <tr>
                                    <th width="40%" onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}
                                    </th>
                                    <th width="20%" onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}
                                    </th>
                                    <th width="20%" onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}
                                    </th>
                                </tr>
                                {PrintPMComments}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-bottom": "0px", "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['PreventativeMaintenance.History.Text'] !== undefined ? label['PreventativeMaintenance.History.Text'] : "History"}</Label> &ensp;
                </Col>
            </FormGroup>
            <FormGroup row style={{ "margin-left": "-28px" }}>
                <Col sm={{ size: 10 }}>
                    <div className="table_container" style={{ "margin-left": "16px" }}>
                        <Table striped responsive className="Custom_table" style={{ 'table-layout': 'fixed' }}>
                            <tbody className="cell_container workordertbl-border">
                                <tr>

                                    <th width="20%" onClick={this.onHistorySort('id')}>{label !== undefined && label['PreventativeMaintenance.Columns.Record.Text'] !== undefined ? label['PreventativeMaintenance.Columns.Record.Text'] : "RECORD#"}

                                    </th>

                                    <th width="20%" onClick={this.onHistorySort('dueDate')}>{label['WorkOrders.HistoryDueDate.Text'] !== undefined ? label['WorkOrders.HistoryDueDate.Text'] : "DUE"}

                                    </th>

                                    <th width="20%" onClick={this.onHistorySort('closedDate')}>{label['WorkOrders.HistoryClosedDate.Text'] !== undefined ? label['WorkOrders.HistoryClosedDate.Text'] : "CLOSED"}

                                    </th>

                                    <th width="20%" onClick={this.onHistorySort('assignedTo')}>{label['WorkOrders.AssignedTo.Text'] !== undefined ? label['WorkOrders.AssignedTo.Text'] : "ASSIGNED TO"}

                                    </th>
                                    <th width="10%"></th>
                                </tr>
                                {PrintHistory}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </FormGroup>
        </div>


        return (
            <div>
                {
                    this.state.redirectToEdit ? <EditPreventativeMaintenance PMId={PMId} Premise={this.props.Premise} ForEquipment={this.props.ForEquipment} UpdateRedirection={this.props.UpdateRedirection} ShowCreateButton={this.props.ShowCreateButton} />
                        :
                        <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                            <Form>
                                <FormGroup row style={{ "margin-bottom": "1px" }}>
                                    <Col sm={{ size: 4 }}>
                                        <Label style={{ fontFamily: 'Lato', fontSize: '14px', color: 'black' }} className="link_cursorUnderlineBlack" onClick={() => { this.togglePMList() }}>{"Preventative Maintenance "}</Label>
                                        <Label style={{ fontFamily: 'Lato', fontSize: '14px', color: 'black' }}>&nbsp;{" > "}{PMSerialNumber}</Label>
                                    </Col>

                                    <Col sm={{ size: 8 }}>
                                        { lUserCanEdit ? <img src={DeleteIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', valign: 'bottom', 'margin-top': '1px', width: '15px', height: '14px' }} onClick={this.OpenDeletePopup}/> : "" }
                                        <FaPrint className="icons-Menu-print" style={{"margin-right":"5px",'display':this.props.ForEquipment ?'none':'block'}} onClick={this.OpenPrintPreview} />
                                        <img src={EditIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', 'margin-top': '1px', width: '15px', height: '14px',"display": IsClosedStatus }} onClick={this.switchEditView} /> 
                                    </Col>
                                </FormGroup>
                                <FormGroup row style={{ "margin-bottom": "1px" }}>
                                    <Col sm={{ size: 2 }}>
                                        <Label style={{ fontFamily: 'Lato', fontSize: '15px', color: 'black', 'font-weight': 'bold' }}>{PMSerialNumber}</Label>
                                    </Col>
                                </FormGroup>
                                <div id="divPrintWindow">
                                <FormGroup row>
                                    {
                                        (Status.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{Status[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{PMStatus}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (Name.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{Name[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl" style={{"word-break": "break-word"}}>{PMName}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (AssignedTo.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{AssignedTo[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{PMAssignedTo}</Label>
                                            </Col> : ""
                                    }
                                    {
                                        (notifyOthers.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{notifyOthers[0].fieldLabel}</Label><br />
                                                {PMNotifyOthers}                                                           
                                            </Col> : ""
                                    }
                                     {
                                        (PMDetails !== undefined && PMDetails.status === 6) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{label['WorkOrderDetails.ClosedDate.Text'] !== undefined ? label['WorkOrderDetails.ClosedDate.Text'] : "Closed Date"}</Label><br />
                                                <Label className="workorderlbl">{PMClosedDate}</Label>
                                            </Col> : ""
                                    }
                                    <Col sm={{ size: 4 }}>
                                        <Label className='workorderheaderlbl'>{label['PMDetails.SheduledDate.Text'] !== undefined ? label['PMDetails.SheduledDate.Text'] : "Due"}</Label><br />
                                        {
                                            IsBasedOnUsage ? UsageRemaining === null ? 
                                                <Label className="workorderlbl">NO DATA AVAILABLE</Label> : 
                                                (UsageRemaining === 0 ? ( IsPastDue ? <div><Label className="workorderlbl" style={{ 'margin-bottom': '1px' }}>{PMScheduledDate}</Label><Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /><Label style={{ 'color': 'red' }} >Past Due</Label></div> :
                                                <Label className="workorderlbl">{PMScheduledDate}</Label>) : 
                                                    <div style={{"width":"35%","margin-top":"-4px"}}><span className="progressbar-label">{UsageRemaining + "% usage remaining"}</span><br/><ProgressBar className="progressbar-border" now={100-UsageRemaining} /></div>)
                                            :
                                            IsPastDue ?
                                                <div><Label className="workorderlbl" style={{ 'margin-bottom': '1px' }}>{PMScheduledDate}</Label><Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /><Label style={{ 'color': 'red' }} >Past Due</Label></div>
                                                : <Label className="workorderlbl">{PMScheduledDate}</Label>
                                        }
                                    </Col>
                                   

                                </FormGroup>


                                <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                                <FormGroup row>
                                    <Col sm={{ size: 2 }}>
                                        <Label className='workordermainheaderlbl printview'>{label['WorkOrderDetails.Details.Text'] !== undefined ? label['WorkOrderDetails.Details.Text'] : "DETAILS"}</Label>
                                    </Col>
                                </FormGroup>
                                {
                                    (Building.length > 0) ?
                                        <FormGroup row>
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{Building[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{PMBuilding}</Label>
                                            </Col>
                                        </FormGroup> : ""
                                }
                                {
                                    (FamilyType.length > 0) ?
                                        <FormGroup row>
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{FamilyType[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{PMFamilyName}</Label>
                                            </Col>
                                        </FormGroup> : ""
                                }
                                <FormGroup row>
                                    {
                                        (Equipment.length > 0) ?
                                            <Col sm={{ size: 2 }}>
                                                <Label className='workorderheaderlbl'>{Equipment[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl" style={{"word-break": "break-word"}}>{PMEquipment}</Label>
                                            </Col> : ""
                                    }

                                    {
                                        (Schedule.length > 0) ?
                                            <Col sm={{ size: 6 }}>
                                                <Label className='workorderheaderlbl'>{Schedule[0].fieldLabel}</Label><br />
                                                <Label className="workorderlbl">{PMScheduleText}</Label>
                                            </Col> : ""
                                    }
                                </FormGroup>
                                {PMCustomFields}
                                {
                                    (Description.length > 0) ?
                                        <FormGroup row>
                                            <Col sm={{ size: 8 }}>
                                                <Label className='workorderheaderlbl'>{Description[0].fieldLabel}</Label><br />
                                                {PMDescription !== "" ?
                                                    <Label className="workorderlbl">{PMDescription}</Label> :
                                                    <Label className="workorderlbl-noentry">No Description</Label>
                                                }
                                            </Col>
                                        </FormGroup> : ""
                                }
                                {(EstimateTime.length > 0) ?
                                    <FormGroup>
                                        <Label className='workorderheaderlbl'>{EstimateTime[0].fieldLabel}</Label><br />
                                        <Label className="workorderlbl">{PMEstimatedTime}</Label>
                                    </FormGroup> : ""
                                }
                                <FormGroup row>
                                    {(PartsAndTools.length > 0) ?
                                        <Col sm={{ size: 4 }}>
                                            <Label className="workorderheaderlbl">{PartsAndTools[0].fieldLabel}</Label><br />
                                            {PMParts}
                                        </Col> : ""
                                    }{(TaskList.length > 0) ?
                                        <Col sm={{ size: 4 }}>
                                            <Label className="workorderheaderlbl">{TaskList[0].fieldLabel}</Label><br />
                                            {PMTaskList}
                                        </Col> : ""
                                    }
                                </FormGroup>
                                </div>
                                <br />
                                <FormGroup row>
                                    {
                                        <Col sm={{ size: 8 }}>
                                            <Label className="workorderlbl" style={{ 'margin-bottom': '10px' }}>Supporting Document(s)</Label><br />
                                            <Table responsive className="attachmentTable" style={{width:"90%"}}>
                                                <tbody>
                                                    <tr><th>ATTACHMENTS</th></tr>
                                                        {PMAttachements}  
                                                </tbody>
                                            </Table>
                                        </Col>
                                    }
                                </FormGroup>
                                <hr style={{'margin-bottom':'0px','background-color':'black'}} />
                                <FormGroup row>
                                    <Col sm={{ size: 12 }}>
                                        <div style={{ backgroundColor: '#EEEEEE', 'width': '102.5%' }}>
                                            <FormGroup row>
                                                <Col sm={{ size: 12 }}>
                                                    <Label style={{ "padding-left": "37px", "padding-top": "24px" }} className='workordersubheaderlbl'>{label['WorkOrderDetails.WorkSummary.Text'] !== undefined ? label['WorkOrderDetails.WorkSummary.Text'] : "WORK SUMMARY"}</Label>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Col sm={{ size: 12 }}>
                                                    <div style={{ "background-color": "white", "width": "98%", "height": "96%", "margin-left": "24px" }}>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Comments.Text'] !== undefined ? label['WorkOrderDetails.Comments.Text'] : "Comments"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.toggleComments() }} >ADD COMMENT </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <div style={{ 'display': this.state.commentModal, "margin-left": "15px", "margin-bottom": "12px", "position":"relative" }}>
                                                                    <FormGroup row style={this.state.isCommentEmpty ? {"margin-bottom": "0px"} : {}}>
                                                                        <Col sm={{ size: 11 }}>
                                                                            <textarea className={this.state.isCommentEmpty ? "errorhighlight custom_input default-input" : "custom_input default-input"} ref='WorkOrder_Comments' rows="4" maxLength="1000" />
                                                                            <span hidden={!this.state.isCommentEmpty} style={{"position":"absolute","top":"50%"}}><Icon name='exclamation triangle' style={ErrorSign} /></span>                                                                                                                                
                                                                        </Col>
                                                                    </FormGroup>
                                                                    <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                                        <Col sm={{ size: 10 }}>
                                                                            <div hidden={!this.state.isCommentEmpty}><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></div>
                                                                            <Button className="btn-gray btn-md ChangeLimits_Cancelbtn" onClick={() => { this.toggleComments() }} >Cancel </Button>
                                                                            <Button className="btn-success btn-md ChangeLimits_Applybtn" onClick={() => { this.SavePMComments() }} >Save </Button>
                                                                        </Col>
                                                                    </FormGroup>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table fixed_layout">
                                                                        <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}&nbsp;&nbsp;<span style={{color:'white'}} className={(this.state.sort.direction[0].name == "comments")? (this.state.sort.direction[0].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="40%" onClick={this.onCommentSort('comments')}>{label['WorkOrders.Comments.Text'] !== undefined ? label['WorkOrders.Comments.Text'] : "COMMENTS"}
                                                                                    <span className={(this.state.sort.direction[0].name == "comments")? 
                                                                                    (this.state.sort.direction[0].onclick)?
                                                                                    (this.state.sort.direction[0].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[0].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}&nbsp;&nbsp;<span className={(this.state.sort.direction[1].name == "createdByUserName")? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onCommentSort('createdByUserName')}>{label['WorkOrders.CreatedBy.Text'] !== undefined ? label['WorkOrders.CreatedBy.Text'] : "CREATED BY"}
                                                                                    <span className={(this.state.sort.direction[1].name == "createdByUserName")? 
                                                                                    (this.state.sort.direction[1].onclick)?
                                                                                    (this.state.sort.direction[1].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[1].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}&nbsp;&nbsp;<span className={(this.state.sort.direction[2].name == "createdOn")? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onCommentSort('createdOn')}>{label['WorkOrders.CreatedDate.Text'] !== undefined ? label['WorkOrders.CreatedDate.Text'] : "CREATED DATE"}
                                                                                    <span className={(this.state.sort.direction[2].name == "createdOn")? 
                                                                                    (this.state.sort.direction[2].onclick)?
                                                                                    (this.state.sort.direction[2].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[2].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {PMComments}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrders.ViewDetails.Parts.Text'] !== undefined ? label['WorkOrders.ViewDetails.Parts.Text'] : "Parts"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.toggle() }} >ADD PART </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                                                                        <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onPartsSort('partName')}>{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[3].name == "partName")? (this.state.sort.direction[3].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onPartsSort('partName')}>{label['WorkOrders.PartsName.Text'] !== undefined ? label['WorkOrders.PartsName.Text'] : "NAME"}
                                                                                    <span className={(this.state.sort.direction[3].name == "partName")? 
                                                                                    (this.state.sort.direction[3].onclick)?
                                                                                    (this.state.sort.direction[3].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[3].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onPartsSort('partNumber')}>{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}&nbsp;&nbsp;<span className={(this.state.sort.direction[4].name == "partNumber")? (this.state.sort.direction[4].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="40%" onClick={this.onPartsSort('partNumber')}>{label['WorkOrders.PartNumber.Text'] !== undefined ? label['WorkOrders.PartNumber.Text'] : "PART #"}
                                                                                    <span className={(this.state.sort.direction[4].name == "partNumber")? 
                                                                                    (this.state.sort.direction[4].onclick)?
                                                                                    (this.state.sort.direction[4].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[4].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onPartsSort('quantity')}>{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}&nbsp;&nbsp;<span className={(this.state.sort.direction[5].name == "quantity")? (this.state.sort.direction[5].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onPartsSort('quantity')}>{label['WorkOrders.PartQuantity.Text'] !== undefined ? label['WorkOrders.PartQuantity.Text'] : "QUANTITY"}
                                                                                    <span className={(this.state.sort.direction[5].name == "quantity")? 
                                                                                    (this.state.sort.direction[5].onclick)?
                                                                                    (this.state.sort.direction[5].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[5].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {Parts}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.Labor.text'] !== undefined ? label['WorkOrderDetails.Labor.text'] : "Labor"}</Label> &ensp;
                                                                <Button className="workorderbtn-black" style={{ "float": "right", "margin-top": "18px" }} onClick={() => { this.Labortoggle() }} >ADD LABOR </Button>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                                                                            <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onLaborSort('userName')}>{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[6].name == "userName")? (this.state.sort.direction[6].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('userName')}>{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}
                                                                                    <span className={(this.state.sort.direction[6].name == "userName")? 
                                                                                    (this.state.sort.direction[6].onclick)?
                                                                                    (this.state.sort.direction[6].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[6].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('dateOfService')}>{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}&nbsp;&nbsp;<span className={(this.state.sort.direction[7].name == "dateOfService")? (this.state.sort.direction[7].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('dateOfService')}>{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}
                                                                                    <span className={(this.state.sort.direction[7].name == "dateOfService")? 
                                                                                    (this.state.sort.direction[7].onclick)?
                                                                                    (this.state.sort.direction[7].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[7].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('regularHour')}>{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}&nbsp;&nbsp;<span className={(this.state.sort.direction[8].name == "regularHour")? (this.state.sort.direction[8].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('regularHour')}>{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}
                                                                                    <span className={(this.state.sort.direction[8].name == "regularHour")? 
                                                                                    (this.state.sort.direction[8].onclick)?
                                                                                    (this.state.sort.direction[8].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[8].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('timeDuration')}>{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[9].name == "timeDuration")? (this.state.sort.direction[9].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onLaborSort('timeDuration')}>{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}
                                                                                    <span className={(this.state.sort.direction[9].name == "timeDuration")? 
                                                                                    (this.state.sort.direction[9].onclick)?
                                                                                    (this.state.sort.direction[9].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[9].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {Labors}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row style={{ "margin-bottom": "0px" }}>
                                                            <Col sm={{ size: 10 }}>
                                                                <Label className='form_title' style={{ "margin-top": "18px", "margin-left": "1px", "fontFamily": "lato", "fontSize": "13px" }}>{label['WorkOrderDetails.History.text'] !== undefined ? label['WorkOrderDetails.History.text'] : "Related Records"}</Label> &ensp;
                                             
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row>
                                                            <Col sm={{ size: 10 }}>
                                                                <div className="table_container" style={{ "margin-left": "16px" }}>
                                                                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                                                                            <tbody className="cell_container workordertbl-border OnPremisetbody">
                                                                            <tr>
                                                                                {/* <th onClick={this.onLaborSort('userName')}>{label['WorkOrders.LaborName.Text'] !== undefined ? label['WorkOrders.LaborName.Text'] : "NAME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[6].name == "userName")? (this.state.sort.direction[6].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onHistorySort('id')}>{label !== undefined && label['PreventativeMaintenance.Columns.Record.Text'] !== undefined ? label['PreventativeMaintenance.Columns.Record.Text'] : "RECORD#"}
                                                                                    <span className={(this.state.sort.direction[10].name == "id")? 
                                                                                    (this.state.sort.direction[10].onclick)?
                                                                                    (this.state.sort.direction[10].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[10].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('dateOfService')}>{label['WorkOrders.LaborDateofService.Text'] !== undefined ? label['WorkOrders.LaborDateofService.Text'] : "DATE OF SERVICE"}&nbsp;&nbsp;<span className={(this.state.sort.direction[7].name == "dateOfService")? (this.state.sort.direction[7].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onHistorySort('dueDate')}>{label['WorkOrders.HistoryDueDate.Text'] !== undefined ? label['WorkOrders.HistoryDueDate.Text'] : "DUE"}
                                                                                    <span className={(this.state.sort.direction[11].name == "dueDate")? 
                                                                                    (this.state.sort.direction[11].onclick)?
                                                                                    (this.state.sort.direction[11].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[11].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('regularHour')}>{label['WorkOrders.LaborRegularHours.Text'] !== undefined ? label['WorkOrders.LaborRegularHours.Text'] : "REGULAR HOURS"}&nbsp;&nbsp;<span className={(this.state.sort.direction[8].name == "regularHour")? (this.state.sort.direction[8].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onHistorySort('closedDate')}>{label['WorkOrders.HistoryClosedDate.Text'] !== undefined ? label['WorkOrders.HistoryClosedDate.Text'] : "CLOSED"}
                                                                                    <span className={(this.state.sort.direction[12].name == "closedDate")? 
                                                                                    (this.state.sort.direction[12].onclick)?
                                                                                    (this.state.sort.direction[12].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[12].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                {/* <th onClick={this.onLaborSort('timeDuration')}>{label['WorkOrders.LaborOvertime.Text'] !== undefined ? label['WorkOrders.LaborOvertime.Text'] : "OVERTIME"}&nbsp;&nbsp;<span className={(this.state.sort.direction[9].name == "timeDuration")? (this.state.sort.direction[9].direction == "asc")?"workorder-sort-direction asc":"workorder-sort-direction desc":"workorder-sort-direction desc"}></span></th> */}
                                                                                <th width="20%" onClick={this.onHistorySort('assignedTo')}>{label['WorkOrders.AssignedTo.Text'] !== undefined ? label['WorkOrders.AssignedTo.Text'] : "ASSIGNED TO"}
                                                                                    <span className={(this.state.sort.direction[13].name == "assignedTo")? 
                                                                                    (this.state.sort.direction[13].onclick)?
                                                                                    (this.state.sort.direction[13].direction == "asc")? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor" 
                                                                                    :(this.state.sort.direction[13].direction == "asc")? "workorder-sort-direction desc" : "workorder-sort-direction desc"
                                                                                    : "workorder-sort-direction desc" }>
                                                                                    </span>
                                                                                </th>
                                                                                <th width="10%"></th>
                                                                            </tr>
                                                                            {PMHistory}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </Col>
                                                        </FormGroup>
                                                    </div>
                                                    <br/>
                                                </Col>
                                            </FormGroup>
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                            <div id="PrintPMSummary" style={{"display":"none"}}>
                                    {PrintPMSummary}
                                </div>
                                            
                            </Form>
                            <Modal isOpen={this.state.modal} toggle={this.toggle} contentClassName="resetContainer">
                                <AddPartsForm ParentToChildData={[PMDetails !== undefined ? PMDetails.id : "", this.state.isEdit, EditPartsDetails,true]} />
                            </Modal>
                            <Modal isOpen={this.state.labormodal} Labortoggle={this.Labortoggle} contentClassName="resetContainer">
                                <AddLaborForm ParentToChildData={[PMDetails !== undefined ? PMDetails.id : "", this.state.isLaborEdit, EditLaborDetails,true]} />
                            </Modal>
                            <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={"ModalContainer short_modal"} >
                                <DeleteConfirmation parentToChildData={["Delete Preventative Maintenance", "You are about to delete a preventative maintenance from the system. Do you want to continue?", "Close Window", "Delete Preventative Maintenance"]} Delete={this.Delete} />
                            </Modal>
                            <div><img id="test_trane_logo" src={TraneLogo} style={{"display":"none"}}/></div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getDetails: state.WorkorderRootReducer,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getCustomFields: state.WorkorderRootReducer.PreventativeMaintenanceCustomFields,
        UserCanEdit: state.authService.HasWorkOrderAccess
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceDetails: (PMId) => dispatch(GetPreventativeMaintenanceDetails(PMId)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        DeletePreventativeMaintenance: (id, equipmentID) => dispatch(DeletePreventativeMaintenance(id, equipmentID)),
        UpdatePMComments: (data) => dispatch(UpdatePMComments(data)),
        DeletePMComments: (data) => dispatch(DeletePMComments(data)),
        SavePMComments: (data) => dispatch(SavePMComments(data)),
        DeletePMParts: (data) => dispatch(DeletePMParts(data)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        DeletePMLaborDetails: (data) => dispatch(DeletePMLaborDetails(data)),
        GetPMCustomFields : () => dispatch(GetPreventativeMaintenanceCustomFields()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreventativeMaintenanceDetails);